import { Content } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import { branch_helper } from "@/helpers/branch_helper";
import * as additionalComponents from "./__components";
import { createTitle } from "@/functions/createTitle";
import { jobs_helper } from "@/helpers/jobs_helper";

export default function BranchPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const branch = branch_helper.find(url_slug);

  return {
    props: {
      meta: {
        title: createTitle(branch.name, "Our Branches"),
        canonical: "https://www.bluearrow.co.uk" + getRoute("branch", { url_slug: url_slug })
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Contact us", href: getRoute("contact") },
              { label: "Our Branches", href: getRoute("branches") },
              { label: branch.name, href: getRoute("branch", { url_slug }) },
            ],
          },
        },
        {
          component: "Header",
          props: {
            variant: branch.header_image_position ?? null,
            className: "text-tertiary",
            title: { path: `page.branch.${url_slug}.component.Header.title`, placeholder: `${branch.name} Branch` },
            back: {
              path: "page.branch.component.Header.back",
              placeholder: `Back to branches`,
              href: getRoute("branches"),
            },
            img: branch.image ?? null,
          },
        },
        { component: "BranchPageContent", props: { ...branch } },
        { component: "Divider" },
        {
          component: "LatestJobs",
          props: {
            title: null, // `Latest Jobs in ${branch.name}`,
            items: jobs_helper.fetch({ limit: 20, branch: branch.id }),
            visibleCount: 4,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: branch_helper.toPaths({ exclude: ['be80efef-220b-4d55-92f9-740785808af9', '7106a96e-cb09-458d-b121-6d8ecaa75d18', '173d2472-d48e-48c6-9e70-ab7909b5ce40', 'd6d7e5c1-8776-4b6e-ac48-4fada518cf16'] }),
    fallback: false,
  };
}
